import { render, staticRenderFns } from "./AudioWrapper.vue?vue&type=template&id=7acd4bd8"
import script from "./AudioWrapper.vue?vue&type=script&lang=js"
export * from "./AudioWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports